export default __webpack_public_path__ + "static/media/line_belly.0b4894ab.png";